import React, { useEffect, useState } from 'react';
import { Text } from 'office-ui-fabric-react';
import { Link } from 'react-router-dom';
import './AddCustomer.scss';
import { IconButton, IIconProps, PrimaryButton, Spinner, SpinnerSize, Link as HLink } from '@fluentui/react';
import DataTable from 'react-data-table-component';
import { SearchMSX } from 'app/modules/user/newReqExperience/searchMSX/SearchMSX';
import { ISelectedData } from 'app/models/common/response';
import { DeviceModelDto, RequestDto, RequestType } from 'generated/request-backend';
import { usePostAddCustomer } from 'app/services/mutations';
import { usePostAddCustomerReviewRequest } from 'app/services/css-api';
import { usePostAddCustomerTechnicalRequest } from 'app/services/cxp-api';
import { CountryDto, CustomerImpactDto, IAddCustomerImpactDto, RequestDomain, UserDto, UserRole } from 'generated/cxp-backend';
import { addCustomerSubmit, isNumberGreaterThanZero, keyPress, searchedColumns } from 'app/components/helpers';
import { ChevronDownIcon } from '@fluentui/react-icons-mdl2';
import { useGetCustomersList } from 'app/services/search-api';
import { MsxSuggestDocument, MsxSuggestResponse } from 'generated/search-backend';
import _ from 'lodash';
import AddMultiDetails from './AddMultiDetails/AddMultiDetails';
import AddNewDetails from './AddNewDetails/AddNewDetails';
import SuccessPopup from './SuccessPopUp/SuccessPopup';
import { Trans, useTranslation } from 'react-i18next';
import AddProduct from 'app/modules/admin/detailsPanel/addProduct/AddProduct';
import useStore, { IStore } from 'app/store';
import { AppQueryClient } from 'app/services/clients/query-client';
import { useGetCountries } from 'app/services/request-api';
import { StringConstants, TelemetryConstants, appInsightsService } from 'app/utils/constants';

interface ISearchProps {
    selectedRequest: RequestDto;
    globalSelectedRequest: RequestDto;
    onDismiss?: () => void;
    onSuccessHandler?: Function;
    setSelectedRequest: Function;
    requestProcessing: boolean;
    setRequestProcessing: (requestProcessing: boolean) => void;
    displayScreen: string;
    setDisplayScreen: (displayScreen: string) => void;
}

const AddCustomer: React.FC<ISearchProps> = (props) => {
    const { t: translate } = useTranslation();
    const {
        selectedRequest,
        onDismiss,
        onSuccessHandler,
        globalSelectedRequest,
        setSelectedRequest,
        displayScreen = 'searchCust',
        setDisplayScreen,
        requestProcessing,
        setRequestProcessing
    } = props;

    const cancelIcon: IIconProps = { iconName: StringConstants.CANCEL };
    const { data: countryList } = useGetCountries();
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails as UserDto);
    const [toggleTable, setToggleTable] = React.useState(false);
    const [customerHelperText] = useState(false);
    const [newCountryHelperText] = useState(false);
    const [searchField, setSearchField] = useState('');
    const [searchedCustomer, setSearchedCustomer] = useState<MsxSuggestDocument[]>([]);
    const [oppId, setOppId] = useState('');
    const [manualData, setManualData] = useState(false);
    const [estimatedValue, setEstimatedValue] = useState('');
    const [matchFound, setMatchFound] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [searchedMSX] = useState('');
    const [successData, setSuccessData] = useState({ customer_name: '', country: '', impacted_revenue: '', skpIdPost: '' });
    const [, setSuggestionSelected] = useState(false);
    const [isFocus, setIsFocus] = useState(false);
    const [, setRevenueRisk] = useState('');
    const [, setImpDevices] = useState('');
    const [, setRevenueHText] = useState(false);
    const [, setImpDevicesHText] = useState(false);
    const [autoSuggestHText, setAutoSuggestHText] = useState();
    const [customerSelected, setCustomerSelected] = useState(false);
    const [selectedAccountId, setSelectedAccountId] = useState('');
    const [lastSelectedOppurtunityId, setLastSelectedOppurtunityId] = useState('');
    const [isSearchText, setIsSearchText] = useState(false);
    const [errorCustomerName, setErrorCustomerName] = useState(false);
    const [errorCountry, setErrorCountry] = useState(false);
    const [errorEstimatedValue, setErrorEstimatedValue] = useState(false);
    const [errorTotalDeviceCount, setErrorTotalDeviceCount] = useState(false);
    const [noDetailsFound, setNoDetailsFound] = useState(false);
    const [originalSelected, setOriginalSelected] = useState([]);
    const [multiFormError] = useState(false);
    const [cssNumber, setCssNumber] = useState<string>();
    const [cssNumberText, setCssNumberText] = useState(false);
    const [isAddNewDetails, setIsAddNewDetails] = useState(false);
    const [addedDevices, setAddedDevices] = useState<DeviceModelDto[]>([]);

    const rowDisabledCriteria = (row: MsxSuggestDocument) => {
        return selectedAccountId && row.accountNumber !== selectedAccountId;
    };

    const handleSelect = (state: { selectedCount: number; selectedRows: Array<MsxSuggestDocument | ISelectedData> }) => {
        if (state.selectedRows.length !== 0) {
            setCustomerSelected(true);
        } else {
            setCustomerSelected(false);
        }
        const { selectedCount, selectedRows } : { selectedCount: number; selectedRows: Array<MsxSuggestDocument | ISelectedData> } = state;
        if (selectedCount === 0) {
            setSelectedAccountId('');
        }
        if (selectedCount === 1) {
            setSelectedAccountId(selectedRows[0]?.accountNumber);
        }
        if (selectedCount > 0) {
            const arr: ISelectedData[] = [];

            setOriginalSelected(selectedRows);

            (selectedRows as ISelectedData[]).forEach((item: ISelectedData) => {
                arr.push({ ...item, revenueErrorText: false, devicesErrorText: false });
            });
            setSelectedData(arr);
        } else {
            setSelectedData([]);
        }
    };

    const [toggledClearRows, setToggledClearRows] = useState(false);
    const handleClearRows = () => {
        setToggledClearRows(!toggledClearRows);
    };
    const {
        data: getCustomersListData,
        mutate: getCustomersList,
        isSuccess: isSuccessGetCustomersListData,
        isLoading: isLoadingCustomerList
    } = useGetCustomersList();

    const handleCustomerSearch = () => {
        setIsSearchText(false);
        setSelectedAccountId('');
        handleClearRows();
        if (searchField.length <= 0) {
            setIsSearchText(true);
            return false;
        }

        if (searchField.trim().length > 0) {
            if (searchField.trim().includes(lastSelectedOppurtunityId) && lastSelectedOppurtunityId.trim() !== '') {
                getCustomersList({searchValue: lastSelectedOppurtunityId, pageSize: 20});
            } else {
                getCustomersList({searchValue: searchField, pageSize: 20});
            }

            setSelectedData([]);
        }
    };

    const {
        mutate: postAddCustomer,
        isSuccess: successPostAddCustomer,
        isError: errorPostAddCustomer,
        isLoading: isPostAddCustomer,
        data: postAddCustomerResponse
    } = usePostAddCustomer();

    const {
        mutate: postAddCustomerRR,
        isSuccess: successPostAddCustomerRR,
        isError: errorPostAddCustomerRR,
        isLoading: isPostAddCustomerRR,
        data: postAddCustomerResponseRR
    } = usePostAddCustomerReviewRequest();

    const {
        mutate: postAddCustomerTR,
        isSuccess: successPostAddCustomerTR,
        isError: errorPostAddCustomerTR,
        isLoading: isPostAddCustomerTR,
        data: postAddCustomerResponseTR
    } = usePostAddCustomerTechnicalRequest();

    const handleAddCustomer = () => {
        setErrorCustomerName(false);
        setErrorCountry(false);
        setErrorEstimatedValue(false);
        setErrorTotalDeviceCount(false);
        setCssNumberText(false);

        if (!selectedData[0] || !selectedData[0]?.accountName) {
            setErrorCustomerName(true);
        }
        if (
            selectedRequest.requestType === RequestType.CssReviewRequest ||
            selectedRequest.requestType === RequestType.CXP_TechnicalRequest
        ) {
            if (!cssNumber || cssNumber === '') {
                setCssNumberText(true);
            }
        }
        if (!selectedData[0] || !selectedData[0].country) {
            setErrorCountry(true);
        }

        if (!selectedData[0] || !selectedData[0].estimatedValue) {
            setErrorEstimatedValue(true);
        }

        if (!selectedData[0] || !selectedData[0].totalDeviceCount) {
            setErrorTotalDeviceCount(true);
        }

        let errorFlag = false;
        selectedData.every((ele) => {
            if (
                !ele?.accountName?.trim() ||
                ele?.accountName?.trim() === '' ||
                !ele?.country?.trim() ||
                ele?.country?.trim() === '' ||
                !isNumberGreaterThanZero(ele?.estimatedValue?.toString().replace('$', '').replaceAll(',', '')) ||
                !ele?.totalDeviceCount?.toString()?.trim() ||
                ele?.totalDeviceCount?.toString()?.trim() === '0' ||
                ele?.totalDeviceCount?.toString()?.trim() === '' ||
                ((selectedRequest.requestType === RequestType.CssReviewRequest ||
                    selectedRequest.requestType === RequestType.CXP_TechnicalRequest) &&
                    (!cssNumber || cssNumber === ''))
            ) {
                errorFlag = true;
                return false;
            } else {
                return true;
            }
        });
        if (selectedData.length === 0) {
            setErrorEstimatedValue(true);
            setErrorCustomerName(true);
            setErrorCountry(true);
            errorFlag = true;
        }

        if (errorFlag) {
            let tempArray: ISelectedData[] = [];

            selectedData.forEach((ele) => {
                let updatedValue = { ...ele };
                if (!ele?.accountName?.trim() || ele?.accountName?.trim() === '') {
                    setErrorCustomerName(true);
                }
                if (!ele?.country?.trim() || ele?.country?.trim() === '') {
                    setErrorCountry(true);
                }
                if (ele?.requestType === RequestType.CssReviewRequest || ele?.requestType === RequestType.CXP_TechnicalRequest) {
                    if (!cssNumber || cssNumber === '') {
                        setErrorCountry(true);
                    }
                }
                if (!isNumberGreaterThanZero(ele?.estimatedValue?.toString().replace('$', '').replaceAll(',', ''))) {
                    if (displayScreen === StringConstants.CAMELCASE_ADD_NEW_DETAILS) {
                    } else {
                        updatedValue.revenueErrorText = true;
                    }
                }
                if (
                    !ele?.totalDeviceCount?.toString()?.trim() ||
                    ele?.totalDeviceCount?.toString()?.trim() === '0' ||
                    ele?.totalDeviceCount?.toString()?.trim() === ''
                ) {
                    if (displayScreen === StringConstants.CAMELCASE_ADD_NEW_DETAILS) {
                    } else {
                        updatedValue.devicesErrorText = true;
                    }
                }
                tempArray.push(updatedValue);
            });
            setSelectedData(tempArray);
            return;
        } else {
            setDisplayScreen('updateProducts');
            return;
        }
    };

    const [addedCustomerImpacts, setAddedCustomerImpacts] = useState<CustomerImpactDto[]>([]);

    const submitAddCustomer = () => {
        let subUrl = addCustomerSubmit({
            team: selectedRequest?.requestTeam,
            requestType: selectedRequest?.requestType,
            skpId: selectedRequest?.unifiedTrackingId
        });
        if (
            selectedRequest.requestType === RequestType.CssReviewRequest ||
            selectedRequest.requestType === RequestType.CXP_TechnicalRequest
        ) {
            let dataPass : IAddCustomerImpactDto = {
                requestId: selectedRequest.unifiedTrackingId,
                cssCaseNumber: cssNumber,
                customerImpacts: selectedData.map((item, index) => (new CustomerImpactDto({
                    ...item,
                    createdOn: Date.now(),
                    opportunityId: item.opportunityNumber,
                    msxOpportunityId: item.opportunityId,
                    accountId: item.accountNumber,
                    customerName: item.accountName,
                    customerImpactDescription: item.customerImpact,
                    status: item.status,
                    customerCountry: new CountryDto({
                        id: item.id,
                        name: item.country
                    }),
                    deviceCount:
                        parseInt(item.totalDeviceCount?.toString().replaceAll(',', '')) ===
                        parseInt(
                            originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.totalDeviceCount
                        )
                            ? 0
                            : parseInt(item.totalDeviceCount?.toString().replaceAll(',', '')),
                    revenue:
                        parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')) ===
                        parseFloat(
                            originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.estimatedValue
                        )
                            ? 0
                            : parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')),
                    msxDeviceCount: isAddNewDetails
                        ? 0
                        : parseInt(
                              originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]
                                  ?.totalDeviceCount
                          ),
                    msxRevenue: isAddNewDetails
                        ? 0
                        : parseFloat(
                              originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.estimatedValue
                          ),
                    addedOn: new Date(),
                    addedBy: new UserDto({
                        id: userDetails.id,
                        displayName: userDetails.displayName,
                        email: userDetails.email,
                        userDomain: userDetails.userDomain as unknown as RequestDomain,
                        userRoles: userDetails.userRoles as UserRole[]
                    }),
                    endCustomerSegment: '',
                    competitor: '',
                    salesPlay: '',
                    refreshYourDevice: ''
                }))),
                deviceModels: globalSelectedRequest.deviceModels
            };
            if (!manualData) {
                let impacts = dataPass.customerImpacts;
                let res: CustomerImpactDto[] = [];
                impacts.forEach((item, index) => {
                    let temp = new CustomerImpactDto({
                        ...item,
                        state: selectedData[index]?.region,
                        city: selectedData[index]?.city,
                        zipCode: selectedData[index]?.postalCode
                    });
                    res.push(temp);
                });
                dataPass = { ...dataPass, customerImpacts: res };
            }
            setAddedCustomerImpacts(dataPass.customerImpacts);
            setSelectedRequest({ ...globalSelectedRequest, updatedCustCssNum: cssNumber });
            if (selectedRequest.requestType === RequestType.CssReviewRequest) {
                postAddCustomerRR({ ...dataPass });
            } else {
                postAddCustomerTR({ ...dataPass });
            }
        } else {
            let dataPass : IAddCustomerImpactDto = {
                requestId: selectedRequest.unifiedTrackingId,
                cssCaseNumber: cssNumber,
                customerImpacts: selectedData.map((item, index) => (new CustomerImpactDto({
                    ...item,
                    opportunityId: item.opportunityNumber,
                    tpId: item.tPID,
                    msxOpportunityId: item.opportunityId,
                    accountId: item.accountNumber,
                    customerName: item.accountName,
                    customerImpactDescription: item.customerImpact,
                    customerCountry: new CountryDto({
                        name: item.country
                    }),
                    deviceCount:
                        parseInt(item.totalDeviceCount?.toString().replaceAll(',', '')) ===
                        parseInt(
                            originalSelected?.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.totalDeviceCount
                        )
                            ? 0
                            : parseInt(item.totalDeviceCount?.toString().replaceAll(',', '')),
                    revenue:
                        parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')) ===
                        parseFloat(
                            originalSelected?.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.estimatedValue
                        )
                            ? 0
                            : parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')),
                    msxDeviceCount: isAddNewDetails
                    ? 0
                    : parseInt(
                              originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]
                                  ?.totalDeviceCount
                          ),
                    msxRevenue: isAddNewDetails
                        ? 0
                        : parseFloat(
                            originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.estimatedValue
                          )
                }))),
                deviceModels: globalSelectedRequest.deviceModels
            };
            if (!manualData) {
                let impacts = dataPass.customerImpacts;
                let res: CustomerImpactDto[] = [];
                impacts.forEach((item, index) => {
                    if (item.msxDeviceCount === item.deviceCount) {
                        item.deviceCount = null;
                    }
                    if (item.msxRevenue === item.revenue) {
                        item.revenue = null;
                    }
                    let temp = new CustomerImpactDto({
                        ...item,
                        state: selectedData[index]?.region,
                        city: selectedData[index]?.city,
                        zipCode: selectedData[index]?.postalCode
                    });
                    res.push(temp);
                });
                dataPass = { ...dataPass, customerImpacts: res };
            }
            setAddedCustomerImpacts(dataPass.customerImpacts);
            postAddCustomer({ subUrl: subUrl, data: dataPass });
        }
        appInsightsService.logRequestflowTelemetry(TelemetryConstants.DEFLECTION_DECISION, "add_existing_customer", {
            'deflected_item_id': selectedRequest.unifiedTrackingId,
        });
    };

    const handleMultiChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, type: string, id: string) => {
        let updateValue = selectedData.slice(0);

        updateValue = updateValue.map((item) => {
            if (item.opportunityNumber === id) {
                switch (type) {
                    case 'impacted_revenue':
                        item.estimatedValue = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        item.revenueErrorText = false;
                        break;
                    case 'impacted_device':
                        item.totalDeviceCount = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        item.devicesErrorText = false;
                        break;
                    case 'accountNumber':
                        item.accountNumber = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        break;
                    case 'accountName':
                        item.accountName = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        break;
                    case 'country':
                        item.country = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        break;
                    case 'customer_impact':
                        item.customerImpact = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        break;
                    case 'css-case-num':
                        setCssNumber((e.target as HTMLInputElement | HTMLTextAreaElement).value);
                        break;
                    default:
                        break;
                }
            }
            return item;
        });
        setSelectedData(updateValue);
    };

    const handleChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, type: string) => {
        let updateValue = selectedData.slice(0);
        if (updateValue.length === 0) {
            updateValue = [{}];
        }

        if (updateValue.length !== 0) {
            switch (type) {
                case 'impacted_revenue':
                    updateValue[0]['estimatedValue'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    setErrorEstimatedValue(false);
                    break;
                case 'impacted_device':
                    updateValue[0]['totalDeviceCount'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    setErrorTotalDeviceCount(false);
                    break;
                case 'accountNumber':
                    updateValue[0]['accountNumber'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    break;
                case 'accountName':
                    updateValue[0]['accountName'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    setErrorCustomerName(false);
                    break;
                case 'country':
                    updateValue[0]['country'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    setErrorCountry(false);
                    break;
                case 'css-case-num':
                    setCssNumber((e.target as HTMLInputElement | HTMLTextAreaElement).value);
                    setCssNumberText(false);
                    break;
                default:
                    break;
            }
        }
        setSelectedData(updateValue);
    };

    const clickHandler = () => {
        handleCustomerSearch();
        setIsFocus(false);
    };

    useEffect(() => {
        setDisplayScreen('searchCust');
        setIsFocus(true);
    }, []);

    useEffect(() => {
        if (selectedData) {
            let totalEstimatedValue = 0;

            selectedData.map(
                (item) =>
                    (totalEstimatedValue =
                        totalEstimatedValue + parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')))
            );

            setEstimatedValue(totalEstimatedValue.toString());
        }
    }, [selectedData]);

    useEffect(() => {
        if (isSuccessGetCustomersListData) {
            let searchData: Array<MsxSuggestDocument> = [];
            searchData = getCustomersListData?.filter(
                    (item: MsxSuggestResponse) =>
                        !_.find(selectedRequest.customerImpacts, (obj) => {
                            return (
                                item.document.accountNumber === obj.accountId &&
                                item.document.opportunityNumber === obj.opportunityId
                            );
                        })
                )
                .map((item: MsxSuggestResponse) => {
                    const {
                        document: {
                            accountName,
                            tpid,
                            country,
                            opportunityNumber,
                            opportunityId,
                            topic,
                            estimatedValue,
                            totalDeviceCount,
                            accountNumber,
                            region,
                            city,
                            postalCode,
                            status
                        }
                    } = item;
                    return new MsxSuggestDocument({
                        accountName,
                        tpid,
                        country,
                        opportunityNumber,
                        opportunityId,
                        topic,
                        estimatedValue,
                        totalDeviceCount,
                        accountNumber,
                        region,
                        city,
                        postalCode,
                        status
                    });
                });
            if (searchData?.length === 0) {
                setNoDetailsFound(true);
            } else {
                setNoDetailsFound(false);
            }
            setSearchedCustomer(searchData);
            appInsightsService.logRequestflowTelemetry(TelemetryConstants.CUSTOMER_SEARCH_RESULTS, "add_existing_customer", {
                "result_count": String(searchData.length)
            })
        }
    }, [isSuccessGetCustomersListData]);

    useEffect(() => {
        if (!isPostAddCustomer) {
            if (successPostAddCustomer) {
                setSuccessData({
                    customer_name: selectedData[0]?.accountName,
                    country: selectedData[0]?.country,
                    impacted_revenue: estimatedValue,
                    skpIdPost: postAddCustomerResponse?.id
                });
                if (onSuccessHandler) {
                    onSuccessHandler(postAddCustomerResponse, addedCustomerImpacts);
                } else {
                    setRequestProcessing(false);
                    setDisplayScreen('successPopUp');
                    AppQueryClient.invalidateQueries('getRequestById');
                }

                globalSelectedRequest.unifiedTrackingId = postAddCustomerResponse?.id;
                setSelectedRequest(globalSelectedRequest);
            } else if (errorPostAddCustomer) {
                setRequestProcessing(false);
                setDisplayScreen('errorPopUp');
            }
        }
    }, [successPostAddCustomer, errorPostAddCustomer, isPostAddCustomer]);

    useEffect(() => {
        if (!isPostAddCustomerRR) {
            if (successPostAddCustomerRR) {
                setSuccessData({
                    customer_name: selectedData[0]?.accountName,
                    country: selectedData[0]?.country,
                    impacted_revenue: estimatedValue,
                    skpIdPost: postAddCustomerResponseRR?.id
                });
                if (onSuccessHandler) {
                    onSuccessHandler(postAddCustomerResponseRR, addedCustomerImpacts);
                } else {
                    setRequestProcessing(false);
                    setDisplayScreen('successPopUp');
                }
                globalSelectedRequest.unifiedTrackingId = postAddCustomerResponseRR?.id;
                setSelectedRequest(globalSelectedRequest);
            } else if (errorPostAddCustomerRR) {
                setRequestProcessing(false);
                setDisplayScreen('errorPopUp');
            }
        }
    }, [successPostAddCustomerRR, errorPostAddCustomerRR, isPostAddCustomerRR]);

    useEffect(() => {
        if (!isPostAddCustomerTR) {
            if (successPostAddCustomerTR) {
                setSuccessData({
                    customer_name: selectedData[0]?.accountName,
                    country: selectedData[0]?.country,
                    impacted_revenue: estimatedValue,
                    skpIdPost: postAddCustomerResponseTR?.id
                });
                if (onSuccessHandler) {
                    onSuccessHandler(postAddCustomerResponseTR, addedCustomerImpacts);
                } else {
                    setRequestProcessing(false);
                    setDisplayScreen('successPopUp');
                }
                globalSelectedRequest.unifiedTrackingId = postAddCustomerResponseTR?.id;
                setSelectedRequest(globalSelectedRequest);
            } else if (errorPostAddCustomerTR) {
                setRequestProcessing(false);
                setDisplayScreen('errorPopUp');
            }
        }
    }, [successPostAddCustomerTR, errorPostAddCustomerTR, isPostAddCustomerTR]);

    const sortData = (data: MsxSuggestDocument[], selectedAccount: string) => {
        const selectedData: MsxSuggestDocument[] = [];
        const otherData: MsxSuggestDocument[] = [];

        for (let i = 0; i < data.length; i++) {
            if (data[i].accountNumber === selectedAccount) {
                selectedData.push(data[i]);
            } else {
                otherData.push(data[i]);
            }
        }
        return selectedData.concat(otherData);
    };

    return (
        <>
            <div>
                {displayScreen === 'searchCust' && (
                    <div className="addImpact-container">
                        <div className={`close-model `}>
                            <IconButton
                                role="button"
                                aria-label="close popup"
                                iconProps={cancelIcon}
                                ariaLabel="Close popup modal"
                                tabIndex={0}
                                onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, onDismiss)}
                                onClick={() => onDismiss()}
                                data-testid="icon-button1"
                            />
                        </div>
                        <div className="modal-heading">
                            <span>
                                <Trans>Add a customer</Trans>
                            </span>
                        </div>
                        <div className="modal-body">
                            <div className="body-main-container ">
                                <Text className="modal-body-title">
                                    <Trans>Search Customer</Trans>
                                </Text>

                                <div className="d-flex">
                                    <div>
                                        <div className="form-control auto-suggest-container">
                                            <label>
                                                <Trans>Search by MSX Opportunity ID / Account ID / Customer Name</Trans>
                                            </label>
                                            <div>
                                                <SearchMSX
                                                    oppId={oppId}
                                                    setOppId={setOppId}
                                                    searchValue={searchField}
                                                    setSearchValue={setSearchField}
                                                    setSuggestionSelected={setSuggestionSelected}
                                                    setFilteredData={setSelectedData}
                                                    setRevenueRisk={setRevenueRisk}
                                                    setImpDevices={setImpDevices}
                                                    setRevenueHText={setRevenueHText}
                                                    setImpDevicesHText={setImpDevicesHText}
                                                    autoSuggestHText={autoSuggestHText}
                                                    setAutoSuggestHText={setAutoSuggestHText}
                                                    origin="ADD_CUSTOMER"
                                                    isFocus={isFocus}
                                                    setCustomerSelected={setCustomerSelected}
                                                    setLastSelectedOppurtunityId={setLastSelectedOppurtunityId}
                                                    setOriginalSelected={setOriginalSelected}
                                                />
                                            </div>

                                            {isSearchText && (
                                                <label className="helper-txt search-error">
                                                    <Trans>Please enter a valid ID/customer name.</Trans>
                                                </label>
                                            )}
                                        </div>
                                    </div>

                                    <div>
                                        <PrimaryButton
                                            onClick={clickHandler}
                                            tabIndex={0}
                                            onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, clickHandler)}
                                            text={translate('Search')}
                                            disabled={selectedData.length !== 0}
                                            data-testid="primary-button"
                                        />
                                    </div>
                                    <div className={`proceed-btn`}>
                                        <PrimaryButton
                                            tabIndex={0}
                                            onClick={() => {
                                                setIsAddNewDetails(false);
                                                setDisplayScreen('addMultiDetails');
                                                setManualData(false);
                                            }}
                                            onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) =>
                                                keyPress(e, () => {
                                                    setIsAddNewDetails(false);
                                                    setDisplayScreen('addMultiDetails');
                                                })
                                            }
                                            text={`Proceed (${selectedData.length})`}
                                            data-testid="addMultiDetails-test"
                                            disabled={selectedData.length === 0 || !customerSelected}
                                            className={selectedData.length === 0 ? 'disabled-button' : ''}
                                        />
                                    </div>
                                </div>
                            </div>

                            {searchedCustomer.length > 1 && (
                                <div className="add-heading" aria-label="Search Results" tabIndex={0}>
                                    <div className="search-count-container">Search Results ({searchedCustomer.length})</div>
                                </div>
                            )}

                            <div className={`body-result-container ${displayScreen === 'searchCust' ? 'add-height' : ''}`}>
                                {toggleTable && !matchFound && searchedMSX === '' && (
                                    <span className="no-results-found">
                                        <Trans>Sorry,we couldn't find any results</Trans>
                                    </span>
                                )}

                                {isLoadingCustomerList && (
                                    <div className="m-t-50">
                                        <Spinner label="Search results are loading. Please wait..." size={SpinnerSize.large} />
                                    </div>
                                )}
                                {noDetailsFound && (
                                    <div tabIndex={0} aria-label="No details found">
                                        No details found
                                    </div>
                                )}
                                {searchedCustomer && searchedCustomer.length > 0 && (
                                    <>
                                        {searchedCustomer.length > 0 && (
                                            <>
                                                <div className="addCustomer-table-container ">
                                                    <DataTable<MsxSuggestDocument>
                                                        columns={searchedColumns(selectedAccountId)}
                                                        data={sortData(searchedCustomer, selectedAccountId)}
                                                        sortIcon={<ChevronDownIcon />}
                                                        selectableRows
                                                        onSelectedRowsChange={handleSelect}
                                                        selectableRowDisabled={rowDisabledCriteria}
                                                        clearSelectedRows={toggledClearRows}
                                                        selectableRowsNoSelectAll
                                                    />
                                                </div>

                                                <div className="btn-link-container">
                                                    <HLink
                                                        tabIndex={0}
                                                        onClick={() => {
                                                            setIsAddNewDetails(true);
                                                            setDisplayScreen(StringConstants.CAMELCASE_ADD_NEW_DETAILS);
                                                            setManualData(true);
                                                        }}
                                                        onKeyPress={(e: React.KeyboardEvent<HTMLAnchorElement>) =>
                                                            keyPress(e, () =>
                                                                setDisplayScreen(StringConstants.CAMELCASE_ADD_NEW_DETAILS)
                                                            )
                                                        }
                                                        className="btn-link link-right">
                                                        <Trans>Can't Find Customer</Trans>
                                                    </HLink>
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {displayScreen === 'addDetails' && !isPostAddCustomer && (
                    <AddNewDetails
                        selectedRequest={selectedRequest}
                        onDismiss={onDismiss}
                        setDisplayScreen={setDisplayScreen}
                        selectedData={selectedData}
                        handleChange={handleChange}
                        handleAddCustomer={handleAddCustomer}
                        customerHelperText={customerHelperText}
                        newCountryHelperText={newCountryHelperText}
                        errorCustomerName={errorCustomerName}
                        errorCountry={errorCountry}
                        errorEstimatedValue={errorEstimatedValue}
                        errorTotalDeviceCount={errorTotalDeviceCount}
                        type="AddDetails"
                        cssNumber={cssNumber}
                        setCssNumber={setCssNumber}
                        cssErrorText={cssNumberText}
                        setErrorText={setCssNumberText}
                        countryList={countryList}
                    />
                )}

                {displayScreen === 'addMultiDetails' && !isPostAddCustomer && (
                    <AddMultiDetails
                        selectedRequest={selectedRequest}
                        onDismiss={onDismiss}
                        setDisplayScreen={setDisplayScreen}
                        selectedData={selectedData}
                        handleMultiChange={handleMultiChange}
                        multiFormError={multiFormError}
                        handleAddCustomer={handleAddCustomer}
                        cssNumber={cssNumber}
                        setCssNumber={setCssNumber}
                        cssErrorText={cssNumberText}
                        setErrorText={setCssNumberText}
                    />
                )}

                {displayScreen === StringConstants.CAMELCASE_ADD_NEW_DETAILS && (
                    <AddNewDetails
                        selectedRequest={selectedRequest}
                        onDismiss={onDismiss}
                        setDisplayScreen={setDisplayScreen}
                        selectedData={selectedData}
                        handleChange={handleChange}
                        handleAddCustomer={handleAddCustomer}
                        customerHelperText={customerHelperText}
                        newCountryHelperText={newCountryHelperText}
                        errorCustomerName={errorCustomerName}
                        errorCountry={errorCountry}
                        errorEstimatedValue={errorEstimatedValue}
                        errorTotalDeviceCount={errorTotalDeviceCount}
                        type="AddNewDetails"
                        cssNumber={cssNumber}
                        setCssNumber={setCssNumber}
                        cssErrorText={cssNumberText}
                        setErrorText={setCssNumberText}
                        countryList={countryList}
                    />
                )}

                {displayScreen === 'successPopUp' && (
                    <SuccessPopup
                        onDismiss={onDismiss}
                        setDisplayScreen={setDisplayScreen}
                        successData={successData}
                        setSearchField={setSearchField}
                        setMatchFound={setMatchFound}
                        setToggleTable={setToggleTable}
                        setSearchedCustomer={setSearchedCustomer}
                        setSelectedData={setSelectedData}
                    />
                )}

                {displayScreen === 'errorPopUp' && (
                    <div className="selected-customer-container">
                        <div className={`close-model close-primary `}>
                            <IconButton
                                role="button"
                                aria-label="close popup"
                                iconProps={cancelIcon}
                                ariaLabel="Close popup modal"
                                tabIndex={0}
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                    onDismiss();
                                }}
                                onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, () => onDismiss())}
                            />
                        </div>
                        <div className="modal-body success-body">
                            <Text className="success-title">
                                <Trans>Something went wrong.</Trans>
                            </Text>
                            <Text className="success-title error-link">
                                <Link to="/submit-feedback">
                                    <Trans>Please tell us about it</Trans>
                                </Link>
                            </Text>
                        </div>
                    </div>
                )}
                {displayScreen === 'updateProducts' && (
                    <AddProduct
                        setCssNumberText={setCssNumberText}
                        addOrUpdate={StringConstants.ADD}
                        selectedRequest={globalSelectedRequest}
                        onDismiss={onDismiss}
                        setDisplayScreen={setDisplayScreen}
                        addedDevices={addedDevices}
                        setAddedDevices={setAddedDevices}
                        handleAddProduct={() => {
                            setRequestProcessing(true);
                            submitAddCustomer();
                            setDisplayScreen('');
                        }}
                    />
                )}
                {requestProcessing && (
                    <Spinner
                        className="p-t-50 p-b-50"
                        size={SpinnerSize.large}
                        label="Please wait, while we are processing your request"
                    />
                )}
            </div>
        </>
    );
};

export default AddCustomer;
